import "swagger-ui-dist/swagger-ui-standalone-preset.js";
import SwaggerUIBundle from "swagger-ui-dist/swagger-ui-bundle.js";
globalThis.SwaggerUIBundle = SwaggerUIBundle;
